import { render, staticRenderFns } from "./ProductGiftCertificate.vue?vue&type=template&id=5d654b2a"
import script from "./ProductGiftCertificate.vue?vue&type=script&lang=js"
export * from "./ProductGiftCertificate.vue?vue&type=script&lang=js"
import style0 from "./ProductGiftCertificate.vue?vue&type=style&index=0&id=5d654b2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports